/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReRateServiceRaiseResponse
 */
export interface ReRateServiceRaiseResponse {
    /**
     * 
     * @type {string}
     * @memberof ReRateServiceRaiseResponse
     */
    reRateId?: string | null;
}

/**
 * Check if a given object implements the ReRateServiceRaiseResponse interface.
 */
export function instanceOfReRateServiceRaiseResponse(value: object): value is ReRateServiceRaiseResponse {
    return true;
}

export function ReRateServiceRaiseResponseFromJSON(json: any): ReRateServiceRaiseResponse {
    return ReRateServiceRaiseResponseFromJSONTyped(json, false);
}

export function ReRateServiceRaiseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReRateServiceRaiseResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'reRateId': json['reRateId'] == null ? undefined : json['reRateId'],
    };
}

export function ReRateServiceRaiseResponseToJSON(json: any): ReRateServiceRaiseResponse {
    return ReRateServiceRaiseResponseToJSONTyped(json, false);
}

export function ReRateServiceRaiseResponseToJSONTyped(value?: ReRateServiceRaiseResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reRateId': value['reRateId'],
    };
}

